import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import CategoryCard from "../components/CategoryCard";

export default function Categories() {
    const [categories, setCategories] = useState([]);
    const [sort, setSort] = useState("count");

    useEffect(() => {
        api.listCategories(sort).then(setCategories).catch(() => {});
    }, [sort]);

    return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6 py-12" data-testid="categories-page">
            <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-8">
                <div>
                    <h1 className="font-heading font-extrabold text-4xl sm:text-5xl tracking-tight text-ink">
                        All 61 Categories
                    </h1>
                    <p className="mt-3 text-ink-muted text-lg">
                        58 categories with verified Indian alternatives ·{" "}
                        <Link
                            to="/opportunities"
                            className="text-saffron font-semibold hover:underline"
                        >
                            3 categories with open opportunities
                        </Link>
                    </p>
                </div>
                <div className="flex gap-2" role="group" aria-label="Sort categories">
                    <button
                        onClick={() => setSort("count")}
                        className={`text-sm font-semibold px-4 py-2 rounded-lg border transition-colors ${
                            sort === "count"
                                ? "border-saffron bg-saffron-50 text-saffron-700"
                                : "border-line bg-white text-ink-muted hover:text-ink"
                        }`}
                        data-testid="sort-by-count"
                    >
                        Most products
                    </button>
                    <button
                        onClick={() => setSort("alpha")}
                        className={`text-sm font-semibold px-4 py-2 rounded-lg border transition-colors ${
                            sort === "alpha"
                                ? "border-saffron bg-saffron-50 text-saffron-700"
                                : "border-line bg-white text-ink-muted hover:text-ink"
                        }`}
                        data-testid="sort-by-alpha"
                    >
                        A → Z
                    </button>
                </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {categories.map((c) => (
                    <CategoryCard key={c.slug} category={c} />
                ))}
            </div>
        </div>
    );
}
